import Vue from "vue";
import axios from "axios";

import mockInterceptor from "@/interceptors/mock.interceptor";
import tokenInterceptor from "@/interceptors/token.interceptor";
import tokenFailedInterceptor from "@/interceptors/token-failed.interceptor";
import { API_URL } from "@/consts/api.consts";

const API = axios.create({
  baseURL: API_URL
});

API.interceptors.request.use(tokenInterceptor, null);
API.interceptors.request.use(mockInterceptor, null);
API.interceptors.response.use(response => {
  Vue.$cookies.set("aad_b2c_session", "active", "1h");
  return response;
}, tokenFailedInterceptor);

export default API;
